// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/soft-field-landing.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/soft-field-landing/soft-field-landing.js';

mount([g0]);
